import {Injectable} from '@angular/core';
import {ProductGroupSummary} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";

@Injectable({
    providedIn: 'root'
})
export class ProductGroupService extends TableOptionsService<ProductGroupSummary> {
    constructor() {
        super();
        this.pageSize = 25;
    }

    public override matches(element: ProductGroupSummary, term: string) {
        return (
            element.name?.toLowerCase().includes(term.toLowerCase())
        );
    }
}
